import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Dumbbell, Loader2 } from 'lucide-react';
import { useAuth } from '@/lib/auth';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card } from '@/components/ui/card';

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            toast.success('Bienvenido');
            navigate('/');
        } catch (err) {
            toast.error(err.response?.data?.detail || 'No se pudo iniciar sesión');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen hero-wash app-bg-noise flex items-center justify-center px-4">
            <div className="w-full max-w-md">
                <div className="flex items-center gap-3 mb-6 justify-center">
                    <div className="h-11 w-11 rounded-xl bg-[hsl(var(--primary))] grid place-items-center">
                        <Dumbbell className="h-6 w-6 text-[hsl(var(--primary-foreground))]" />
                    </div>
                    <div className="font-display font-semibold text-2xl tracking-tight">FitHome</div>
                </div>
                <Card className="bg-card border-border p-6">
                    <h1 className="text-2xl font-semibold mb-1 font-display">Iniciar sesión</h1>
                    <p className="text-sm text-muted-foreground mb-6">Entra para ver tu rutina</p>
                    <form onSubmit={submit} className="space-y-4">
                        <div>
                            <Label htmlFor="email">Email</Label>
                            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="tu@email.com" data-testid="auth-email-input" className="mt-1" />
                        </div>
                        <div>
                            <Label htmlFor="password">Contraseña</Label>
                            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="••••••••" data-testid="auth-password-input" className="mt-1" />
                        </div>
                        <Button type="submit" className="w-full h-12 text-base" disabled={loading} data-testid="auth-submit-button">
                            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Entrar'}
                        </Button>
                    </form>
                    <div className="mt-6 text-sm text-muted-foreground text-center">
                        ¿No tienes cuenta?{' '}
                        <Link to="/register" className="text-[hsl(var(--primary))] hover:underline" data-testid="go-register-link">Regístrate</Link>
                    </div>
                </Card>
            </div>
        </div>
    );
}
